import React from 'react';
import { Link, browserHistory } from 'react-router';
import classNames from 'classnames';
import styles from './itemMenu.module.scss';
import { scholaMatchLink } from 'constants/url-links';

const ItemMenu = (props) => {
  const { to, displayName, icon, className, external = false } = props;
  const { pathname, query } = browserHistory.getCurrentLocation();

  const attributes = {
    ...(external ? { href: to } : { to }),
    ...(external && { target: '_blank' }),
  };

  const linkClasses = {
    [styles.item]: true,
    [styles.active]: pathname.includes(to),
    [className]: className,
  };

  let params = query.gclid ? `?gclid=${query.gclid}` : '';
  if (query.fbclid) params += `${params === '' ? '?' : '&'}fbclid=${query.fbclid}`;

  return to === '/scholaMatch' ? (
    <Link target="_blank" href={`${scholaMatchLink}${params}`} className={classNames(linkClasses)}>
      <span>
        <>
          {icon} <span>{displayName}</span>
        </>
      </span>
    </Link>
  ) : (
    <Link className={classNames(linkClasses)} {...attributes}>
      <span>
        <>
          {icon} <span>{displayName}</span>
        </>
      </span>
    </Link>
  );
};

export default ItemMenu;
